import { Button } from '@acpaas-ui/react-components';
import SimpleSearch from '../../../../components/core/SimpleSearch';
import { MODALS } from '../../../../constants/modals.constants';
import { useForm } from '../../../../hooks/useForm.hook';
import { useModal } from '../../../../hooks/useModal.hook';
import { useSimpleSearch } from '../../../../hooks/useSimpleSearch.hook';
import AddPartnerModal from '../../../../modals/admin/AddPartnerModal';
import UpdatePartnerModal from '../../../../modals/admin/UpdatePartnerModal';
import { ADMIN_PARTNERS_RESOURCE } from '../../../../resources/admin/admin.partners.resource';
import ResourceTable from '../../../core/ResourceTable';

const resource = ADMIN_PARTNERS_RESOURCE;

const AdminOrganizationsPartners = () => {
  const addPartnerModal = useModal(MODALS.ADD_PARTNER_MODAL);
  const updatePartnerModal = useModal(MODALS.UPDATE_PARTNER_MODAL);
  const partnerForm = useForm({});

  const handleOpenPartner = (data) => {
    partnerForm.load(data);
    updatePartnerModal.onOpen();
  };

  return (
    <div className="spo-o-admin-partners">
      <SimpleSearch className="u-margin-bottom" {...useSimpleSearch(resource, 'name')} />
      <ResourceTable
        resource={resource}
        onRowClick={handleOpenPartner}
        actions={[
          <Button
            key={'partners-add'}
            iconRight="ai-add"
            className="u-margin-right-sm"
            size="small"
            onClick={addPartnerModal.onOpen}
          >
            Partner toevoegen
          </Button>
        ]}
      />
      {addPartnerModal.isOpen && <AddPartnerModal {...addPartnerModal} />}
      {updatePartnerModal.isOpen && <UpdatePartnerModal {...updatePartnerModal} form={partnerForm} />}
    </div>
  );
};

export default AdminOrganizationsPartners;
